<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            prepend-icon="search"
            v-model="search"
            append-icon="search"
            label="User ID, Customer name"
            single-line
            hide-details
            style="padding: 0"
            @input="
              fetching_log = true;
              debounceInput();
            "
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :loading="fetching_log"
      :items="promotionLog"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center" style="font-weight: bold">
          {{ currentPage * pageItems - (pageItems - props.index - 1) }}
        </td>
        <td class="text-xs-center">{{ props.item.used_promotion_code }}</td>
        <td class="text-xs-center">{{ props.item.used_user_id }}</td>
        <td class="text-xs-center">{{ props.item.customer_name }}</td>
        <td class="text-xs-center">{{ props.item.used_price }}</td>
        <td class="text-xs-center">{{ props.item.used_date }}</td>
        <td class="text-xs-center">{{ props.item.used_time }}</td>
      </template>

      <template slot="no-data">
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <div>No data available</div>
          <div v-if="fetching_log == false">
            <v-btn
              flat
              :loading="fetching_log"
              @click="initialize()"
              style="
                font-size: 14px;
                text-decoration: underline;
                color: cornflowerblue;
              "
              >Click to reset</v-btn
            >
          </div>
        </div>
      </template>
    </v-data-table>

    <div style="display: flex; align-items: center; justify-content: center">
      <div
        style="
          width: 50vw;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        class="my-3"
      >
        <v-pagination
          class="mt-3"
          v-model="currentPage"
          :length="totalItems"
          @input="initialize()"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      promotionLog: [],
      fetching_log: false,
      search: "",
      headers: [
        {
          text: "#",
          align: "center",
          sortable: false,
          value: "num",
        },
        {
          text: "Promotion code",
          align: "center",
          value: "use_pro_code",
          sortable: false,
        },
        {
          text: "User ID",
          align: "center",
          value: "use_pro_user_id",
          sortable: false,
        },
        {
          text: "Customer name",
          align: "center",
          value: "use_pro_user_fullname",
          sortable: false,
        },
        {
          text: "Discount price",
          align: "center",
          value: "use_pro_price",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "use_pro_date",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "use_pro_time",
          sortable: false,
        },
      ],
      totalItems: 0,
      currentPage: 1,
      pageItems: 50,
    };
  },
  computed: {},
  methods: {
    debounceInput: _.debounce(function (e) {
      this.currentPage = 1;
      this.initialize();
    }, 1000),
    async initialize() {
      this.fetching_log = true;
      let payload = {
        promotion_id: this.$route.params.promotion_id,
        page_size: this.pageItems,
        current_page: this.currentPage,
        search: this.search || undefined,
      };
      let response = await this.$store.dispatch(
        "fetchFoodPromotionBack/fetchPromoLogAllProvince",
        payload
      );
      this.promotionLog = response.list;
      this.totalItems = Math.ceil(response.total / this.pageItems);
      this.fetching_log = false;
    },
  },
  async created() {
    this.initialize();
  },
};
</script>

<style></style>
